import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
// Body type strings got from message body
var HTML_BODY_TYPE = 'HTML';
var TEXT_BODY_TYPE = 'Text';
// Markup type string got from user options
var HTML_MARKUP_TYPE = 'Html';
export default function getDefaultBodyType() {
    var composeMarkup = getUserConfiguration().UserOptions.ComposeMarkup;
    var bodyType = composeMarkup == HTML_MARKUP_TYPE ? 'HTML' : 'Text';
    return bodyType;
}
export { HTML_BODY_TYPE, TEXT_BODY_TYPE };
//# sourceMappingURL=getDefaultBodyType.js.map